import React, {Component} from 'react';
import {APIClient} from "../../../utils/APIClient";
import {URLQueryStringParser} from "../../../utils/URLQueryStringParser";
import {API_URL} from '../../../settings/local_settings';
import {Loading} from "../../Loading";
import { LINKEDIN_CHANNEL } from '../../channels/channels';


import {withRouterParams} from "../../../utils/withRouterParams";

class ConnectLinkedin extends Component {
    constructor(props) {
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    componentDidMount() {
        let code = new URLQueryStringParser().getUrlParams('code');
        let auth_code = new URLQueryStringParser().getUrlParams('auth_code');
        let credential_label = localStorage.getItem('pending_credential_label');
        localStorage.removeItem('pending_credential_label');
        let pendingReconnectAdAccountId = localStorage.getItem('pending_reconnect_ad_account_id');
        localStorage.removeItem('pending_reconnect_ad_account_id');
        let postData = {'code': code, 'auth_code': auth_code, 'credential_label': credential_label};
        if (pendingReconnectAdAccountId) {
            postData['reconnect_ad_account_id'] = pendingReconnectAdAccountId;
        }
        new APIClient(API_URL + 'get_access_tokens/linkedin/').call('POST', postData).then((data) => {
            if (data.status === 'ERROR') {
                alert(data['error_message']);
                this.props.history.push('/agency/conections?just_connected=' + LINKEDIN_CHANNEL);
            } else if (data.status === 'OK') {
                this.props.history.push('/agency/conections?just_connected='+LINKEDIN_CHANNEL);
                alert('La cuenta de LinkedIn Ads fue vinculada con éxito!')
            }
        })
    }

    render() {
        return <Loading message="Por favor espere mientras se conecta su cuenta."/>
    }
}

export default withRouterParams(ConnectLinkedin);
